<g
	id="nightmarker-{{id}}"
	class="night-marker"
	transform="translate(0,{{position}})"
	stroke="{{color}}"
	fill="none">

	<g transform="translate(0,-30)">
		<rect x="-73.65" y="42" width="15" height="5.978" stroke="none" fill="#fff"></rect>
		<path d="m-87 39.39a5.387 5.387 0 0 0-4.928 5.367 5.387 5.387 0 0 0 5.387 5.387 5.387 5.387 0 0 0 3.188-1.045 5.387 5.387 0 0 1-0.4512 0.01953 5.387 5.387 0 0 1-5.387-5.387 5.387 5.387 0 0 1 2.199-4.342 5.387 5.387 0 0 0-0.0078 0z" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" style="paint-order:markers fill stroke"/>
		<text
			id="nightmarker-{{id}}-text"
			x="-57"
			y="46.7"
			text-anchor="end"
			fill="{{color}}"
			font-size="8px"
			stroke-width=".2646">
			{{value}}°C
		</text>
	</g>
</g>
